module.exports = __webpack_public_path__ + "img/promise.f7eec57b.png";